module.exports = __webpack_public_path__ + "img/icon_createactivity@2x.3743fe09.png";